import { Controller } from "@hotwired/stimulus"
import { logEvent } from "../field_logger"
import { SNAPSHOT_KEY as SYNC_BAR_SNAPSHOT_KEY } from "./field_sync_banner_controller"

// Logs discrete user-initiated events to the field diagnostic log.
// Actions are fire-and-forget — navigation is never blocked.
//
// Usage:
//   data-action="click->field-log-event#signOut"
export default class extends Controller {
  signOut() {
    logEvent("session", "User signed out").catch(() => {})
    // Card #3863 -- the sync queue bar's last state belongs to this tasker.
    try { sessionStorage.removeItem(SYNC_BAR_SNAPSHOT_KEY) } catch { /* private mode */ }
  }
}
